import { useState, useEffect } from 'react';

export function Hero() {
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  
  const titles = [
    { line1: "Experience the future", line2: "with DJT drone aircraft." },
    { line1: "Fly above traffic", line2: "in DJT electric aircraft." },
    { line1: "DJT: Zero emissions", line2: "unlimited possibilities." }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTitleIndex((prev) => (prev + 1) % titles.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [titles.length]);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full bg-black">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="https://static.nim.video/output/wf-output/zQONc6hPRjDfwAEbuDZd__output_0.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>

      {/* Content */}
      <div className="relative h-full flex items-end pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="space-y-6">
            {/* Launch Announcement */}
            <div className="mb-4 animate-fade-in-up">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500/20 to-cyan-500/20 backdrop-blur-sm border border-teal-400/30 rounded-full px-6 py-3 shadow-lg">
                <i className="ri-rocket-line text-teal-400 text-xl animate-bounce"></i>
                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
                  <span className="text-teal-400 font-semibold text-sm md:text-base animate-pulse">
                    Launching Soon in India
                  </span>
                  <span className="hidden sm:inline text-white/60">•</span>
                  <span className="text-white/90 text-sm md:text-base">
                    Andhra Pradesh, Visakhapatnam
                  </span>
                </div>
                <i className="ri-map-pin-line text-teal-400 text-xl animate-pulse"></i>
              </div>
            </div>

            {/* Main Titles */}
            <h1 
              key={`title1-${currentTitleIndex}`}
              className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight animate-fade-in"
            >
              {titles[currentTitleIndex].line1}
            </h1>
            <h1 
              key={`title2-${currentTitleIndex}`}
              className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight animate-fade-in-delay"
            >
              {titles[currentTitleIndex].line2}
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}
